<app-header />
<div class="page-wrapper">
  <main id="main-content" tabindex="-1">
    <router-outlet />
  </main>
  <app-footer [class.voice-chat-hidden]="browserSharedService.hideFooter()" />
</div>
